import React from 'react';
import Page from './page';

export const LoginLayout = () => {
  return (
      <Page />
  );
}

export default LoginLayout;